export default __webpack_public_path__ + "static/media/artistPage.997f2c92.jpg";